import { IOpenSettingsPanelAction } from './types';

export const openSettingsPanelAction = (openMenu: boolean): IOpenSettingsPanelAction => ({
  type: "OPEN_SETTINGS_PANEL",
  payload: openMenu
})

